import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchClueCreate as fetchCreate } from "@/api/PMS/customerService/lostAndFound/lostManagement";
import { getToken } from "@/utils/auth"; // getToken from cookie

export default {
  props: ["keyValue", "showDialog"],
  data: function data() {
    return {
      files: [],
      fileList: [],
      changeFileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      importHeaders: {
        "access-token": getToken()
      },
      rules: {
        clueName: [{
          required: true,
          message: "请输入线索名称",
          trigger: "blur"
        }],
        clueContent: [{
          required: true,
          message: "请输入线索内容",
          trigger: "blur"
        }]
      },
      Id: "",
      childData: {},
      options: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.changeFileList = [];
      this.files = [];
      this.fileList = [];
      this.$nextTick(function () {
        _this.$refs["dataForm"].clearValidate();
      });
      this.childData = {};
    },
    handCreate: function handCreate() {
      var _this2 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          _this2.childData.goodsSearchNoticeId = _this2.keyValue;
          _this2.childData.resultFiles = _this2.changeFileList;
          fetchCreate(_this2.childData).then(function (res) {
            if (res.data.code === 200) {
              _this2.$emit("handCancle", true);

              _this2.Alert({
                alertType: "add",
                message: "提供线索成功"
              });
            }
          });
        } else {
          _this2.Alert({
            alertType: "valid"
          });
        }
      });
    },
    handleSuccess: function handleSuccess(response, file) {
      // this.fileList.push({
      //   name: response.data[0].fileName,
      //   fileType: this.judgeFileType(file.raw.type),
      //   fileId: response.data[0].fileId,
      // });
      this.changeFileList.push({
        name: response.data[0].fileName,
        fileType: this.judgeFileType(file.raw.type),
        fileId: response.data[0].fileId
      });
    },
    handleExceed: function handleExceed() {
      this.$message({
        message: "最多只能上传3个文件!",
        type: "error"
      });
    },
    handlePreview: function handlePreview(file) {
      if (file.response !== undefined) {
        // 当还未保存到业务逻辑中时的预览图片
        if (file.raw.type === "image/png" || file.raw.type === "image/jpeg" || file.raw.type === "image/jpg") {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].failId;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      } else {
        // 当已保存到业务逻辑中时的预览图片
        if (file.fileType === 2) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = file.url;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = file.url;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      }
    },
    // 移除图片之前做的操作
    beforeRemove: function beforeRemove(file, fileList) {// return this.$confirm(`确定移除 ${ file.name }？`)
    },
    beforeUpload: function beforeUpload(file) {
      var extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      extension = extension.toLowerCase();
      var isLt2M = file.size / 1024 / 1024 < 10;
      var fileFormatOK = extension === "jpg" || extension === "jpeg" || extension === "JPEG" || extension === "png" || extension === "bmp" || extension === "gif";

      if (!fileFormatOK) {
        this.$message({
          message: "只支持上传 jpg/jpeg/png/bmp/gif 格式文件!",
          type: "error"
        });
        return false;
      }

      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 10MB!",
          type: "error"
        });
        return false;
      }
    },
    // 移除图片
    handleRemove: function handleRemove(file) {
      var _this3 = this;

      console.log(file);
      var currentUrl = 0; // 获取当前删除的url

      var currentFileName = ""; // 获取当前删除的名

      var currentFileType = ""; // 获取当前删除的类型

      if (file.response !== undefined) {
        // 是新增加的
        currentUrl = file.response.data[0].fileId;
        currentFileName = file.response.data[0].fileName;
        currentFileType = file.raw.type;
      } else {
        // 是旧数据
        currentUrl = file.fileId;
        currentFileName = file.name;
        currentFileType = file.type;
      }

      this.files.forEach(function (item, index) {
        if (currentUrl == item.fileId) {
          _this3.files.splice(index, 1);

          return;
        }
      });
      this.fileList.forEach(function (item, index) {
        console.log(item);

        if (currentUrl == item.fileId) {
          _this3.fileList.splice(index, 1);

          return;
        }
      });
      this.changeFileList.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this3.changeFileList.splice(index, 1);

          return;
        }
      });
    },
    // 下载文件
    handleDownload: function handleDownload(url, name) {
      var link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
    },
    // 判断上传的文件类型，方便数据库保存
    judgeFileType: function judgeFileType(str) {
      if (str === "image/png" || str === "image/jpeg" || str === "image/jpg" || str === "image/gif" || str === "image/bmp") {
        return 2;
      } else {
        return 1;
      }
    },
    handCancle: function handCancle() {
      this.$emit("handCancle", false);
    }
  }
};